/**
 * Spare room property limit states from the backend:
 * - null — unlimited
 * - 0 — no access
 * - > 0 — capped
 */

export function hasSpareRoomLimitAccess(
  limit: number | null,
  live: number = 0,
): boolean {
  return limit === null || limit > 0 || live > 0;
}

export function formatSpareRoomLimit(limit: number | null): string {
  if (limit === null) {
    return '∞';
  }

  return limit.toLocaleString();
}

/**
 * Progress fill for spare room (or live property) indicators.
 * Unlimited (null) never shows as full; no-access (0) is treated as full.
 */
export function livePropertiesLimitPercentage(
  live: number,
  limit: number | null,
): number {
  if (limit === null) {
    return 0;
  }

  if (limit === 0) {
    return 100;
  }

  return Math.min(100, (live / limit) * 100);
}

export function isSpareRoomLimitReached(
  live: number,
  limit: number | null,
): boolean {
  return limit !== null && limit > 0 && live >= limit;
}
